// This is the master data of the BTW tool. It describes which choices lead to which BTW regimes.

import { ResultCompulsoryPage } from "../../pages/btwtoolpages/ResultCompulsoryPage";
import { ResultCompulsorySmallCompanyPage } from "../../pages/btwtoolpages/ResultCompulsorySmallCompanyPage";
import { ResultExemptPage } from "../../pages/btwtoolpages/ResultExemptPage";
import { ResultMixedCompulsoryPage } from "../../pages/btwtoolpages/ResultMixedCompulsoryPage";
import { ResultMixedCompulsorySmallCompanyPage } from "../../pages/btwtoolpages/ResultMixedCompulsorySmallCompanyPage";
import { Sector, ActivityType, BTW, NonExemptTurnOver, TurnOver } from "./btwtoolenums";
import { BTWToolState } from "./btwtoolstate";
import { ResultValueAndPage } from "../statemachine/resultvalueandpage";

const exempt: Array<BTWToolState> = [
    new BTWToolState({ sector: Sector.Medical, activityType: ActivityType.Therapeutic }),
    new BTWToolState({ sector: Sector.Education }),
    new BTWToolState({ sector: Sector.Insurance }),
]

const compulsory: Array<BTWToolState> = [
    new BTWToolState({ sector: Sector.Horeca }),
    new BTWToolState({ sector: Sector.Construction }),
    new BTWToolState({ sector: Sector.Waste }),
    new BTWToolState({ sector: Sector.LiberalProfession, turnOver: TurnOver.MoreThan25k }),
    new BTWToolState({ sector: Sector.Consulting, turnOver: TurnOver.MoreThan25k }),
    new BTWToolState({ sector: Sector.Retail, turnOver: TurnOver.MoreThan25k }),
    new BTWToolState({ sector: Sector.Other, turnOver: TurnOver.MoreThan25k }),
]

const compulsorySmallCompany: Array<BTWToolState> = [
    new BTWToolState({ sector: Sector.LiberalProfession, turnOver: TurnOver.LessThan25k }),
    new BTWToolState({ sector: Sector.Consulting, turnOver: TurnOver.LessThan25k }),
    new BTWToolState({ sector: Sector.Retail, turnOver: TurnOver.LessThan25k }),
    new BTWToolState({ sector: Sector.Other, turnOver: TurnOver.LessThan25k }),
]

const mixedCompulsory: Array<BTWToolState> = [
    new BTWToolState({ sector: Sector.Medical, activityType: ActivityType.notFullyTherapeutic, nonExemptTurnOver: NonExemptTurnOver.MoreThan25k })
]

const mixedCompulsorySmallCompany: Array<BTWToolState> = [
    new BTWToolState({ sector: Sector.Medical, activityType: ActivityType.notFullyTherapeutic, nonExemptTurnOver: NonExemptTurnOver.LessThan25k })
]

export const masterdata = new Map<ResultValueAndPage<BTW>, Array<BTWToolState>>([
    [new ResultValueAndPage<BTW>(ResultExemptPage, BTW.Exempt), exempt],
    [new ResultValueAndPage<BTW>(ResultCompulsoryPage, BTW.Compulsory), compulsory],
    [new ResultValueAndPage<BTW>(ResultCompulsorySmallCompanyPage, BTW.CompulsorySmallCompany), compulsorySmallCompany],
    [new ResultValueAndPage<BTW>(ResultMixedCompulsoryPage, BTW.MixedCompulsory), mixedCompulsory],
    [new ResultValueAndPage<BTW>(ResultMixedCompulsorySmallCompanyPage, BTW.MixedCompulsorySmallCompany), mixedCompulsorySmallCompany],
])
